import React, { Component } from 'react';
import { IMAGES } from '../Images';

import './Loader.css';

export default class Loader extends Component {
  render() {
    return (
      <>
        <div className="loader-container">
          <div className="loader-image">
            <img src={IMAGES.LOGO_LIGHT} alt="logo" />
          </div>
        </div>
      </>
    );
  }
}
